const initialState = {
    loading: false,
    ministries: [],
    error: null,
    saving: false,
    selectedMinistry: null,
  };
  
  const ministriesReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_MINISTRIES_REQUEST":
        return { ...state, loading: true, error: null };
  
      case "FETCH_MINISTRIES_SUCCESS":
        return { ...state, loading: false, ministries: action.payload || [] };
  
      case "FETCH_MINISTRIES_FAILURE":
        return { ...state, loading: false, error: action.payload };
  
      case "SAVE_MINISTRY_SUCCESS":
        return {
          ...state,
          ministries: [...(state.ministries || []), ...(action.payload || [])],
        };
  
      case "DELETE_MINISTRY_SUCCESS":
        return {
          ...state,
          ministries: state.ministries.filter((m) => m._id !== action.payload._id),
        };
  
      case "UPDATE_MINISTRY_SUCCESS":
        return {
          ...state,
          ministries: state.ministries.map((m) =>
            m._id === action.payload._id ? action.payload : m
          ),
        };
  
      case "FETCH_MINISTRY_BY_ID_SUCCESS":
        return { ...state, selectedMinistry: action.payload };
  
      default:
        return state;
    }
  };
  
  export default ministriesReducer;
  